<template>
    <div class="flex flex-wrap">
        <div class="w-full lg:w-1/3">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-bar-horizontal
                    chart_id="claims_reported"
                    :title="$t('dashboard.graph_title.claims_reported')"
                    dataset_endpoint="/api/dashboard/graphs/claims_reported"
                    :filter_params="filter_params"
                    :filter_limit="6"
                    default_sub_filter="insurer"
                    :sub_filter_options="claims_reported_filter_options"
                    :view_more="true"
                    :view_more_title="$t('dashboard.view_more_title.claims_reported')"
                    :view_more_limit="10"
                    @viewMoreInfo="handleViewMore"
                />
            </div>
        </div>
        <div class="w-full lg:w-1/3">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-bar-horizontal
                    chart_id="stolen_vehicles"
                    :title="$t('dashboard.graph_title.stolen_vehicles')"
                    dataset_endpoint="/api/dashboard/graphs/stolen_vehicles"
                    :filter_params="filter_params"
                    :filter_limit="6"
                    default_sub_filter="vehicle"
                    :sub_filter_options="stolen_vehicles_filter_options"
                    :view_more="true"
                    :view_more_title="$t('dashboard.view_more_title.stolen_vehicles')"
                    :view_more_limit="10"
                    @viewMoreInfo="handleViewMore"
                />
            </div>
        </div>
        <div class="w-full lg:w-1/3">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-bar-horizontal
                    chart_id="upload_frequency"
                    :title="$t('dashboard.graph_title.upload_frequency')"
                    dataset_endpoint="/api/dashboard/graphs/upload_frequency"
                    :filter_params="filter_params"
                    :filter_limit="6"
                    default_sub_filter="count"
                    :sub_filter_options="query_frequency_filter_options"
                    :view_more="true"
                    :view_more_title="$t('dashboard.view_more_title.upload_frequency')"
                    :view_more_limit="10"
                    @viewMoreInfo="handleViewMore"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-doughnut
                    chart_id="total_loss"
                    :title="$t('dashboard.graph_title.total_loss')"
                    dataset_endpoint="/api/dashboard/graphs/total_loss"
                    :filter_params="filter_params"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-bar-vertical
                    chart_id="query_executed"
                    :title="$t('dashboard.graph_title.query_executed')"
                    dataset_endpoint="/api/dashboard/graphs/query_executed"
                    :filter_params="filter_params"
                    :filter_limit="6"
                    default_sub_filter="insurer"
                    :sub_filter_options="query_executed_filter_options"
                    :view_more="true"
                    :view_more_title="$t('dashboard.view_more_title.query_executed')"
                    :view_more_limit="10"
                    @viewMoreInfo="handleViewMore"
                />
            </div>
        </div>
    </div>
</template>

<script>
import GraphBarHorizontal from '@/components/graphs/BarHorizontal.vue';
import GraphBarVertical from '@/components/graphs/BarVertical.vue';
import GraphDoughnut from '@/components/graphs/Doughnut.vue';

export default {
    components: {
        GraphBarHorizontal,
        GraphBarVertical,
        GraphDoughnut,
    },
    props: {
        filter_params: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            claims_reported_filter_options: [
                {
                    value: 'class',
                    text: this.$t('dashboard.filter_options.claims_reported.class'),
                },
                {
                    value: 'insurer',
                    text: this.$t('dashboard.filter_options.claims_reported.insurer'),
                },
                {
                    value: 'loss_type',
                    text: this.$t('dashboard.filter_options.claims_reported.loss_type'),
                },
                {
                    value: 'year',
                    text: this.$t('dashboard.filter_options.claims_reported.year'),
                },
            ],
            stolen_vehicles_filter_options: [
                {
                    value: 'insurer',
                    text: this.$t('dashboard.filter_options.stolen_vehicles.insurer'),
                },
                {
                    value: 'vehicle',
                    text: this.$t('dashboard.filter_options.stolen_vehicles.vehicle'),
                },
            ],
            query_executed_filter_options: [
                {
                    value: 'insurer',
                    text: this.$t('dashboard.filter_options.query_executed.company'),
                },
                {
                    value: 'users',
                    text: this.$t('dashboard.filter_options.query_executed.users'),
                },
            ],
            query_frequency_filter_options: [
                {
                    value: 'count',
                    text: this.$t('dashboard.filter_options.frequency.count'),
                },
                {
                    value: 'record',
                    text: this.$t('dashboard.filter_options.frequency.record'),
                },
            ],
        };
    },
    methods: {
        handleViewMore(data) {
            this.$emit('viewMoreInfo', data);
        },
    },
};
</script>
